module.exports = __webpack_public_path__ + "1ee32a7ad622bc27ad4d24d47d12b52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-video-play.png
// module id = 266
// module chunks = 0